/* Chango Adventure: acceso asistido a reservas. Configurar numero WhatsApp Business antes de activar enlace directo. */
(function(){
  var config={phone:"",greeting:"Hola, quiero consultar por una experiencia de Chango Adventure."};
  if(!config.phone){return;}
  function init(){
    if(document.getElementById("chango-whatsapp"))return;
    var a=document.createElement("a");
    a.id="chango-whatsapp";
    a.href="https://wa.me/"+config.phone+"?text="+encodeURIComponent(config.greeting);
    a.target="_blank";a.rel="noopener noreferrer";
    a.textContent="¿Dudas? Escríbenos por WhatsApp";
    a.setAttribute("aria-label","Consultar por WhatsApp a Chango Adventure");
    a.style.cssText="position:fixed;right:18px;bottom:18px;z-index:9999;background:#176b46;color:white;padding:14px 18px;border-radius:28px;font:700 14px Arial,sans-serif;text-decoration:none;box-shadow:0 6px 22px rgba(0,0,0,.2)";
    document.body.appendChild(a);
  }
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",init);else init();
})();